import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const data = handleActions(
  {
    [actionTypes.GET_REFERENCE_DATA_SUCCESS]: (
      state,
      { payload: {
        results,
        objectType,
        name,
        hasSubTypes,
        valueProperty,
        serviceCenterId,
      } },
    ) => {
      // if it has subtypes, don't destruct
      if (hasSubTypes) {
        return { ...state, [`${serviceCenterId}_${objectType}_${name}`]: results.items[name] };
      }

      // If another property other than 'items[name]' holds the data,
      // use that property
      if (valueProperty) {
        return {
          ...state,
          [`${serviceCenterId}_${objectType}_${name}`]: [...results[valueProperty]],
        };
      }

      // default: array with items spreaded
      return { ...state, [`${serviceCenterId}_${objectType}_${name}`]: [...results.items[name]] };
    },
    [actionTypes.GET_REFERENCE_DATA_FAILURE]: (
      state,
      { payload: { objectType, name, serviceCenterId } },
    ) => ({
      ...state,
      [`${serviceCenterId}_${objectType}_${name}`]: null,
    }),
    [actionTypes.CLEAR_REFERENCE_DATA]: () => ({}),
  },
  {},
);

export const loadingState = handleActions(
  {
    [actionTypes.GET_REFERENCE_DATA_REQUEST]: (
      state,
      { payload: { objectType, name, serviceCenterId } },
    ) => ({
      ...state,
      [`${serviceCenterId}_${objectType}_${name}`]: true,
    }),
    [combineActions(
      actionTypes.GET_REFERENCE_DATA_SUCCESS,
      actionTypes.GET_REFERENCE_DATA_FAILURE,
    )]: (state, { payload: { objectType, name, serviceCenterId } }) => ({
      ...state,
      [`${serviceCenterId}_${objectType}_${name}`]: false,
    }),
    [actionTypes.CLEAR_REFERENCE_DATA]: () => ({}),
  },
  {},
);

export const errorState = handleActions(
  {
    LOCATION_CHANGE: () => ({}),
    [combineActions(
      actionTypes.GET_REFERENCE_DATA_REQUEST,
      actionTypes.GET_REFERENCE_DATA_SUCCESS,
    )]: (state, { payload: { objectType, name, serviceCenterId } }) => ({
      ...state,
      [`${serviceCenterId}_${objectType}_${name}`]: {},
    }),
    [actionTypes.GET_REFERENCE_DATA_FAILURE]: (
      state,
      { payload: { objectType, name, error, serviceCenterId } },
    ) => ({
      ...state,
      [`${serviceCenterId}_${objectType}_${name}`]: error,
    }),
    [actionTypes.CLEAR_REFERENCE_DATA]: () => ({}),
  },
  {},
);

export default combineReducers({
  data,
  loadingState,
  errorState,
});
